import { Spinner } from '@patternfly/react-core'
import { CheckIcon, ErrorCircleOIcon } from '@patternfly/react-icons'
import * as React from 'react'

import * as Patients from '@app/state/patients'

interface Props {
  updateStatus?: Patients.PatientActionStatusId
}

export const UpdatePatientStatus = ({ updateStatus }: Props) => {
  let statusContent = null
  let statusText = null
  switch (updateStatus) {
    case Patients.PatientActionStatusId.Pending:
      statusContent = <Spinner size="sm" />
      break

    case Patients.PatientActionStatusId.Succeeded:
      statusContent = <CheckIcon size="sm" color="green" />
      statusText = 'Patient updated successfully'
      break

    case Patients.PatientActionStatusId.Failed:
      statusContent = <ErrorCircleOIcon size="sm" color="red" />
      statusText = 'Patient update failed'
      break

    default:
      break
  }
  return (
    <div>
      {statusContent}
      {statusText}
    </div>
  )
}
